import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "trip-payment-deposit-confirmation-dialog",
  templateUrl: "trip-payment-deposit-confirmation-dialog.component.html",
  styleUrls: [],
})
export class TripPaymentDepositConfirmationDialogComponent implements OnInit {
  constructor(
    private _dialog: MatDialogRef<TripPaymentDepositConfirmationDialogComponent>
  ) {
  }

  ngOnInit() {
  }

  onConfirm() {
    this._dialog.close(true);
  }

  onCancel() {
    this._dialog.close(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/trips/trip-payment-deposit-confirmation-dialog/trip-payment-deposit-confirmation-dialog.component.ts